/**
 * @module app.shared
 */

export function getValue(target: object, property: string): any {
    let v: any = target;
    for(let p of property.split('.')) {
        if(!v) return v;
        v = v[p];
    }
    return v;
}

export function setValue(target: object, property: string, value: any): boolean {
    const props = property.split('.');
    const last = props.pop();
    if(last === undefined) {
        return false;
    }
    let v: any = target;
    for(let p of props) {
        if(v[p] === undefined) {
            v[p] = {};
        }
        v = v[p];
    }
    v[last] = value;
    return true;
}

export type DeepProxy<T> = T & {
    [key: string]: any
}

export function deep<T extends object>(obj: NonNullable<T>): DeepProxy<T> {
    return new Proxy<T>(obj, {
        get: getValue,
        set: setValue
    });
}
